import { Box, Image, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

import Cta from "areas/info/cta"
import { jewlr_t } from "helpers/application"

import { TitleWithLine } from "../components"

import Banner from "./banner"
import { GemLink } from "./components"
import {
  simulated as getSimulated,
  zirconiaStones as getZirconiaStones,
  ctaFirst as getCc,
  ctaSecond as getCtaSecond,
} from "./gems"
import GemstonesBlock from "./gemstones-block"
import GenuineGemstones from "./genuine-gemstones"
import TitleSection from "./titleSection"

const CtaWrapper = styled(Box).attrs({
  bg: { _: "#E9ECF3", tablet: "white" },
  height: { _: "350px", tablet: "auto" },
  mx: 2,
})``

let refs = {
  genuineGemtones: null,
  simulatedGemtones: null,
  zirconiaGemtones: null,
}

const Gemstones = () => {
  const simulated = getSimulated()
  const zirconiaStones = getZirconiaStones()
  const ctaFirst = getCc()
  const ctaSecond = getCtaSecond()

  return (
    <>
      <Banner refs={refs} />
      <GenuineGemstones refs={refs} />

      <CtaWrapper>
        <Cta
          data={ctaFirst}
          imageStyle={{
            height: { _: "350px", tablet: "auto" },
            width: "auto",
          }}
          primary
        />
      </CtaWrapper>
      <TitleSection
        gemRefs={(ref) => {
          refs.simulatedGemtones = ref
        }}
        text={`Simulated gemstones are man-made and mimic the ${jewlr_t(
          "terms.color"
        )} of genuine gemstones. They offer a comparable look at a fraction of the cost.`}
        title="Simulated Gemstones"
      />
      <GemstonesBlock
        gemStones={simulated}
        showLink
        showMonth
        simulatedStone
        stoneTextStyle={{ px: { _: "3px", tablet: "6px" } }}
      />
      <Box contain mb="50px" textAlign="center">
        <TitleWithLine mb={{ _: 2, tablet: 4 }}>
          Other Simulated Gemstones
        </TitleWithLine>
        <Box>
          <Image
            alt="Moissanite"
            mb={1}
            src={`${sl.config.jewlr_asset_url}images/product/stones/100px/1x/side/04DIAM_RD.png`}
            width="65px"
          />
          <Typography fontWeight="700" pb="4px" px={2}>
            Moissanite
          </Typography>
          <GemLink
            data-lc="gemstones"
            fontSize={16}
            to="/helpdesk/search?query=moissanite"
          >
            Learn More
          </GemLink>
        </Box>
      </Box>
      <CtaWrapper>
        <Cta
          data={ctaSecond}
          imageStyle={{
            height: { _: "350px", tablet: "auto" },
            width: "auto",
          }}
          primary
        />
      </CtaWrapper>
      <TitleSection
        gemRefs={(ref) => {
          refs.zirconiaGemtones = ref
        }}
        text="Our premium lab-crafted stones feature distinctive brilliance and sparkling cuts that set
        them apart from other simulated gemstones."
        title="Brilliance Gemstone Collection"
      />
      <GemstonesBlock
        gemStones={zirconiaStones}
        stoneTextStyle={{ px: "6px" }}
      />
    </>
  )
}

export default Gemstones
